{
  "team_application.title": "Application to {{team_profile_name}}",
  "new.title": "New Application",
  "new.description": "Apply to join a team or express interest in being considered.",
  "new.initial_status_label": "Application Type",
  "new.initial_status.consideration": "Expression of Interest",
  "new.initial_status.consideration_description": "Share your details to start a conversation about joining this team.",
  "new.initial_status.ready_to_accept": "Direct Application",
  "new.initial_status.ready_to_accept_description": "Submit a direct application for this team to review and accept.",
  "new.message_label": "Message",
  "new.ready_to_accept_pro_forma": "I’d love to join your teaching team.\nLooking forward to contributing!",
  "new.consideration_pro_forma": "I’m interested in joining your teaching team.\nI’d love to connect and discuss possibilities.",
  "team_application_sent": "Application submitted.",
  "team_application_rejected": "Application declined.",
  "team_application_accepted": "Application accepted.",
  "team_application_cancelled": "Application withdrawn.",
  "team_application_ready_to_accept": "Application ready for review.",
  "response": {
    "new": {
      "title": "Application from {{teacher_name}}",
      "accept": "Accept",
      "reject": "Decline",
      "status_description": {
        "ready_to_accept": "{{teacher_name}} has applied to join {{team_profile_name}}. Review and decide below.",
        "consideration": "{{teacher_name}} has expressed interest in joining {{team_profile_name}}. You can reach out to discuss next steps.",
        "accepted": "This application from {{teacher_name}} has been accepted.",
        "rejected": "This application from {{teacher_name}} has been declined.",
        "cancelled": "This application from {{teacher_name}} has been withdrawn."
      },
      "warning": "This decision is permanent and cannot be undone.",
      "accept_info": {
        "heading": "Accept Application",
        "description": "{{teacher_name}} will become a member of your team with full access to shared resources."
      },
      "reject_info": {
        "heading": "Decline Application",
        "description": "{{teacher_name}} will be notified that their application was not successful. This action cannot be undone."
      }
    }
  },
  "index": {
    "title": "Active Applications",
    "empty_list_title": "No Active Applications",
    "empty_list_description": "Teachers can apply to join your team. Their applications will appear here.",
    "find": "Find Teachers",
    "profile": "View Profile",
    "actions": {
      "accept": "Accept",
      "accept_description": "The teacher will be added to your team and given access to shared resources. Continue?",
      "reject": "Reject",
      "reject_description": "This will reject the application. Continue?"
    },
    "status": {
      "ready_to_accept": "Under Review",
      "consideration": "Expression of Interest"
    }
  }
}
